"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useConfirm = useConfirm;
exports.PrimeVueConfirmSymbol = void 0;

var _vue = require("vue");

var PrimeVueConfirmSymbol = Symbol();
exports.PrimeVueConfirmSymbol = PrimeVueConfirmSymbol;

function useConfirm() {
  var PrimeVueConfirm = (0, _vue.inject)(PrimeVueConfirmSymbol);

  if (!PrimeVueConfirm) {
    throw new Error('No PrimeVue Confirmation provided!');
  }

  return PrimeVueConfirm;
}
